(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imiloa-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('imiloa-look')) {
    customElements.define('imiloa-look', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.rows = [...this.querySelectorAll('[data-look-row]')];
        this.button = this.querySelector('[data-look-submit]');
        this.status = this.querySelector('[data-look-status]');
        this.money = new Intl.NumberFormat(this.dataset.locale || 'es', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.form.addEventListener('change', () => this.update());
        this.form.addEventListener('submit', event => this.add(event));
        this.update();
      }
      update() {
        let total = 0, count = 0;
        this.rows.forEach(row => {
          const include = row.querySelector('input[type="checkbox"]');
          const select = row.querySelector('[data-look-variant]');
          const quantity = row.querySelector('[data-look-quantity]');
          if (!select) return;
          select.disabled = !include.checked;
          select.required = include.checked;
          quantity.disabled = !include.checked;
          const price = Number(select.selectedOptions[0]?.dataset.price || row.dataset.price);
          row.querySelector('[data-look-price]').textContent = this.money.format(price / 100);
          if (include.checked) {total += price; count++;}
        });
        this.querySelector('[data-look-total]').textContent = this.money.format(total / 100);
        this.button.disabled = count === 0;
      }
      async add(event) {
        event.preventDefault();
        if (this.busy || !this.form.reportValidity()) return;
        const items = this.rows.filter(row => row.querySelector('input[type="checkbox"]').checked).map(row => ({id:row.querySelector('[data-look-variant]')?.value,quantity:1})).filter(item => item.id);
        if (!items.length) {this.status.textContent = this.status.dataset.empty; return;}
        this.busy = true;
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.busy;
        this.status.textContent = '';
        try {
          const response = await fetch(this.dataset.cartAdd, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('cart');
          this.status.textContent = this.status.dataset.success;
          window.location.assign(this.dataset.cartUrl);
        } catch(error) {
          this.status.textContent = this.status.dataset.error;
          this.busy = false;
          this.button.textContent = this.button.dataset.idle;
          this.update();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
